import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login/login.service';
import { LogTackingService } from '../../services/logs/log-tacking.service';
import { LoadingService } from '../../services/general/loading.service';
import { LogsTrackingRequest, LogsTrackingResponse } from '../../interfaces/logs_tracking.interface.';
import { Router, NavigationEnd, RouterOutlet, RouterLink } from '@angular/router';
import { FooterComponent } from "../shared/footer/footer.component";
import { NavbarComponent } from "../shared/navbar/navbar.component"
import { CommonModule } from '@angular/common'
import { getUserRoles, hasRole } from '../../utils/roles.util';

@Component({
  selector: 'app-general-interface',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    FooterComponent,
    NavbarComponent,
    CommonModule
  ],
  templateUrl: './general-interface.component.html',
  styleUrl: './general-interface.component.css'
})
export class GeneralInterfaceComponent implements OnInit {

  userName: any = ''
  actuallyDate: any = ''
  ip: any = ''
  activeTab: string = ''
  userRoles: string[] = []
  token : any = ''
  welcomeMessage = 'Bienvenid@'
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Logout',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private _loginService: LoginService,
    private _logsService: LogTackingService,
    private _loadingService: LoadingService,
    private _router: Router
  ) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeTab = this._router.url.split('/')[2]
      }
    });
  }

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken')
    this.userRoles = getUserRoles()
    this.userName = localStorage.getItem('userName')
    this.userName = this.userName.split("@")[0]
    this.actuallyDate = this.getActuallyDate()
    this._loginService.getIPAddress().subscribe((data: any) => {
      this.ip = data.IPv4
      localStorage.setItem('ip', this.ip)
    });

  }

  /** True si el usuario tiene el rol indicado (soporta múltiples roles en custom:rol). */
  hasRole(role: string): boolean {
    return hasRole(this.userRoles, role);
  }

  getActuallyDate() {
    const currentDate = new Date();

    const month = currentDate.getMonth() + 1; // Months start from 0
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();

    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');

    const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}`;

    return formattedDate
  }

  logout() {
    this._loadingService.setLoading(true)
    this._loginService.logout().subscribe({
      next: (response) => { 
        this.log_info.details = 'Success: Cierre de sesion con exito'
        this.createTrackingLog()
      }, error: (error) => {
        this.log_info.details = 'Error: Fallo al cerrar sesion'
        this.createTrackingLog()
      },
      complete: () => {
        this._loadingService.setLoading(false)
      }
    })
    this._router.navigate(['/login']);
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this._loadingService.setLoading(false)
      }
    });
  }
}
